import React from "react";
import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";
import orgCompleteChecked from "../../../assets/icons/orgCompleteChecked.svg";
import StepNavigationButtons from "../../../components/Reusables/StepControls/StepNavigationButtons";

const OrganisationSuccessStep = ({ onBack, onProceed, loading }) => (
  <Box
    sx={{
      width: "100%",
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Stack spacing={3} alignItems="center" textAlign="center" sx={{ maxWidth: 640 }}>
      {/*Green check icon */}
      <img src={orgCompleteChecked} width={68} height={88} alt="" />

      <Typography
        sx={{
          fontSize: "26px !important",
          fontWeight: 700,
          color: "var(--app-text)",
          fontFamily: "Figtree",
        }}
      >
        Organisation added successfully!
      </Typography>

      <Typography
        sx={{
          fontSize: "16px !important",
          fontWeight: 400,
          color: "#5F6368",
          lineHeight: "26px",
          fontFamily: "Figtree",
          textAlign: "left",
        }}
      >
        Congratulations! Next, let’s add your first centre.{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          Centres are the individual locations where you conduct ECG tests,
          like clinics, hospitals, or diagnostic labs.
        </Box>
      </Typography>

      {/*  Paragraph 2 */}
      <Typography
        sx={{
          fontSize: "16px !important",
          fontWeight: 400,
          color: "#5F6368",
          lineHeight: "26px",
          fontFamily: "Figtree",
          textAlign: "left",
        }}
      >
        Adding centers helps you manage testing, reporting, and monitoring
        across all your sites from one platform.
      </Typography>

      <Box sx={{ width: "100%", mt: 2 }}>
        <StepNavigationButtons
          onBack={onBack}
          onProceed={onProceed}
          loading={loading}
        />
      </Box>
    </Stack>
  </Box>
);

OrganisationSuccessStep.propTypes = {
  onBack: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default OrganisationSuccessStep;
